<template>
  <div class="dropdown mb-2">
    <button class="btn btn-secondary" :disabled="disabled" type="button" data-toggle="dropdown" aria-haspopup="true"
      aria-expanded="false">
      <i class='ri-more-fill'></i>
    </button>
    <div class="dropdown-menu" aria-labelledby="orderActions">
      <a class="dropdown-item" data-toggle="modal" data-target="#printLabelsModal" href='#'>{{ t('features.vue.orders.actions.print_labels') }}</a>
      <a class="dropdown-item" @click="exportCsv" href='#'>{{ t('features.vue.orders.actions.export_csv') }}</a>
      <a class="dropdown-item" @click="exportInvoiceRevenue" href='#'>{{ t('features.vue.orders.actions.export_invoice_revenue') }}</a>
      <a class="dropdown-item" @click="exportPrintErrorReport" href='#'>{{ t('features.vue.orders.actions.export_print_error_report') }}</a>
      <a class="dropdown-item" data-toggle="modal" data-target="#adjustOrdersModal" href='#'>{{ t('features.vue.orders.actions.adjust_orders') }}</a>
    </div>
    <print-labels-modal :filters='filters' :shipping-methods='shippingMethods' />

    <oms-adjust-orders-modal
    :filters='filters'
    :current-tags='currentTags || []'
    :hold-status-reasons='holdStatusReasons || []'
    :addons="addons || {}"
    :addon_groups="addon_groups || {}"
    :statuses="statuses"
    :total-results='totalResults' />
  </div>
</template>

<script>
import buildQueryString from "../../helpers/query-builder";
import PrintLabelsModal from './print-labels-modal.vue';
import OmsAdjustOrdersModal from './adjust-orders-modal.vue';

export default {
  inject: ['i18n'],

  props: {
    disabled: Boolean,
    filters: Object,
    shippingMethods: Array,
    holdStatusReasons: Array,
    currentTags: Array,
    addons: Object,
    addon_groups: Object,
    statuses: Object,
    totalResults: Number
  },

  methods: {
    t(key, options) {
      return this.i18n.t(key, options)
    },

    exportCsv() {
      window.location.href = `orders/export?${buildQueryString(this.filters, 'q')}`
    },

    exportInvoiceRevenue() {
      window.location.href = `orders/export_invoice_revenue?${buildQueryString(this.filters, 'q')}`
    },
    exportPrintErrorReport() {
      window.location.href = `orders/export_print_error_report?${buildQueryString(this.filters, 'q')}`
    }
  },
  components: {
    PrintLabelsModal,
    OmsAdjustOrdersModal
  }
}

</script>
